import SimpleViewPageHeader from "@/App/Layouts/PageHeader/SimpleViewPageHeader";

import ChatPaginatedList, { ChatPaginatedListProps, inboxColumns } from "./ChatPaginatedList";

enum InboxListVariant {
  Paginated = "Paginated",
  // InfiniteScroll = "InfiniteScroll",
}

export interface InboxListProps extends ChatPaginatedListProps {}

export default function InboxList({
  variant = InboxListVariant.Paginated,
  defaultValues,
  displayProps,
  ...props
}: InboxListProps & { variant?: InboxListVariant }) {
  return (
    <>
      {variant === InboxListVariant.Paginated && (
        <ChatPaginatedList
          defaultValues={{
            isActiveParticipant: true, // where active participant
            hasMessages: true, // display non-empty chats
            ...defaultValues,
          }}
          displayProps={{
            breadcrumbs: false,
            header: false,
            columns: inboxColumns,
            ...displayProps,
          }}
          header={<SimpleViewPageHeader title='Inbox' />}
          {...props}
        />
      )}
      {/* {variant === InboxListVariant.InfiniteScroll && <InfiniteScrollInboxList {...props} />} */}
    </>
  );
}
